import React, { useState } from "react";
import { Link } from "react-scroll";
import { FaTelegram, FaTwitter } from "react-icons/fa";
import MethereumImage from "../components/images/Methereum.png";

const Home: React.FC = () => {
  const [showContract, setShowContract] = useState<boolean>(false);
  const contractAddress = "soon";

  const copyToClipboard = () => {
    navigator.clipboard.writeText(contractAddress);
    // Consider using a toast notification here for better UX
    alert("Contract address copied to clipboard!");
  };

  return (
    <div style={{ padding: "20px", textAlign: "center" }} className="home">
      <h1
        style={{ fontFamily: "'Psychedelic Font', cursive", fontSize: "3rem" }}
      >
        Welcome to Methereum (METH)
      </h1>
      <img
        src={MethereumImage}
        alt="Methereum logo showcasing the token"
        style={{
          borderRadius: "20px",
          margin: "20px 0",
          height: "300px",
          width: "300px",
        }}
      />
      <p style={{ fontSize: "1.2rem" }}>
        Methereum is the next big meme coin on BSC.
      </p>

      <div className="cta-buttons" style={{ marginTop: "20px" }}>
        <button
          style={{
            backgroundColor: "#ff007f",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            marginRight: "10px",
            transition: "background-color 0.3s",
          }}
          aria-label="Buy on PancakeSwap"
          onClick={() => window.open("https://pancakeswap.finance", "_blank")} // Link to PancakeSwap
        >
          Buy on PancakeSwap
        </button>
        <button
          style={{
            backgroundColor: "#00ffbf",
            color: "#333333",
            padding: "10px 20px",
            borderRadius: "5px",
            transition: "background-color 0.3s",
          }}
          onClick={() => setShowContract(!showContract)}
          aria-label={
            showContract ? "Hide contract address" : "View contract address"
          }
        >
          {showContract ? "Hide Contract" : "View Contract"}
        </button>
        {showContract && (
          <p
            style={{
              color: "#00ffbf",
              marginTop: "10px",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={copyToClipboard}
          >
            {contractAddress}
          </p>
        )}
      </div>

      <div className="cta-buttons" style={{ marginTop: "20px" }}>
        <Link to="tokenomics" smooth={true} duration={500}>
          <button
            style={{
              backgroundColor: "#7f00ff",
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "5px",
              marginRight: "10px",
              transition: "background-color 0.3s",
            }}
            aria-label="View Tokenomics"
          >
            Tokenomics
          </button>
        </Link>
        <Link to="about" smooth={true} duration={500}>
          <button
            style={{
              backgroundColor: "#ff007f",
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "5px",
              transition: "background-color 0.3s",
            }}
            aria-label="About Methereum"
          >
            About
          </button>
        </Link>
      </div>

      <div className="socials" style={{ marginTop: "30px" }}>
        <p>Follow us on our Socials:</p>
        <a
          href="https://t.me/+B1NQ72aGGv85ZWJk"
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginRight: "10px", color: "#fff" }}
          aria-label="Follow us on Telegram"
        >
          <FaTelegram size={30} />
        </a>
        <a
          href="https://twitter.com/methereumonbnb"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#fff" }}
          aria-label="Follow us on Twitter"
        >
          <FaTwitter size={30} />
        </a>
      </div>
    </div>
  );
};

export default Home;
